'use strict';

module.exports = {
  position: true,
  gfm: true,
  commonmark: false,
  footnotes: false,
  pedantic: false,
  blocks: require('./block-elements.json')
};



//////////////////
// WEBPACK FOOTER
// ./~/remark-parse/lib/defaults.js
// module id = 130
// module chunks = 170434399708630 202660965941462